import { Injectable } from '@angular/core';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IRecommendedActionWrapper } from './recommended-action-wrapper.interface';
import { DeviceStatusType } from '../shared/models/device-status-type.interface';

@Injectable({
    providedIn: 'root'
})
export class RecommendedActionService {
    public static $name: string = 'recommendedActionService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getActions(deviceType: string, deviceStatusType: DeviceStatusType): angular.IPromise<IRecommendedActionWrapper> {
        return this.proxyService.request({
            endPoint: this.getEndpointName(),
            queryParams: {
                'searchCriteria.deviceStatus': deviceStatusType,
                'searchCriteria.deviceType': deviceType
            },
            route: 'getRecommendedActions'
        }
        ).as<IRecommendedActionWrapper>();
    }

    public getEndpointName() {
        return 'deviceRecommendedAction';
    }
}
